import PropertiesSection from './PropertiesSection';

export default PropertiesSection;
